import { PrimaryFunction } from './primary-function';
import { Pba } from './pba';
import { Collapsible } from '../interfaces';

export class TestedParty implements Collapsible {
  testedPartyId: number;
  name: string;
  segmentType: number;
  justification: string;
  primaryFunction: PrimaryFunction;
  pba: Pba;
  collapsed: boolean;
  otherPrimaryFunction?: string;
}
